import { render, staticRenderFns } from "./userAddModal.vue?vue&type=template&id=2e048168&scoped=true&"
import script from "./userAddModal.vue?vue&type=script&lang=ts&"
export * from "./userAddModal.vue?vue&type=script&lang=ts&"
import style0 from "./userAddModal.vue?vue&type=style&index=0&id=2e048168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e048168",
  null
  
)

export default component.exports